// Invoice Generator Utility
// Purpose: Generate downloadable invoices for paid audit orders
// Logos are fully inlined as SVG — no external file dependencies

const LOGO_ICON_SVG = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="22" height="22" viewBox="0 0 375 374.999991" preserveAspectRatio="xMidYMid meet" version="1.0"><defs><clipPath id="b06538117f"><path d="M 140 2.175781 L 372.671875 2.175781 L 372.671875 281 L 140 281 Z M 140 2.175781 " clip-rule="nonzero"/></clipPath><clipPath id="ac86bc50f9"><path d="M 2.175781 81 L 264 81 L 264 372.671875 L 2.175781 372.671875 Z M 2.175781 81 " clip-rule="nonzero"/></clipPath><clipPath id="16fa2a243d"><path d="M 2.175781 81 L 210 81 L 210 372.671875 L 2.175781 372.671875 Z M 2.175781 81 " clip-rule="nonzero"/></clipPath></defs><g clip-path="url(#b06538117f)"><path fill="#0082fb" d="M 372.816406 2.175781 L 372.816406 280.078125 L 283.480469 280.078125 C 295.625 268.628906 305.058594 255.015625 311.710938 239.238281 C 318.363281 223.460938 321.765625 206.210938 321.765625 187.496094 C 321.765625 168.542969 318.441406 151.21875 311.710938 135.519531 C 305.058594 119.816406 295.546875 106.203125 283.25 94.679688 C 270.949219 83.15625 256.640625 74.261719 240.242188 68.074219 C 223.847656 61.882812 205.902344 58.789062 186.488281 58.789062 L 140.621094 58.789062 L 140.621094 2.175781 Z M 372.816406 2.175781 " fill-opacity="1" fill-rule="nonzero"/></g><g clip-path="url(#ac86bc50f9)"><path fill="#000000" d="M 209.847656 314.574219 L 209.847656 372.738281 L 2.175781 372.738281 L 2.175781 81.53125 L 83.386719 81.53125 L 83.386719 316.199219 L 187.261719 316.199219 C 194.996094 316.121094 202.578125 315.65625 209.847656 314.574219 Z M 253.394531 145.1875 C 246.972656 133.507812 237.921875 124.535156 226.398438 118.191406 C 214.875 111.851562 201.339844 108.679688 185.792969 108.679688 L 140.621094 108.679688 L 140.621094 265.769531 L 185.792969 265.769531 C 201.339844 265.769531 214.953125 262.675781 226.632812 256.488281 C 238.308594 250.300781 247.28125 241.25 253.625 229.339844 C 259.96875 217.425781 263.0625 203.351562 263.0625 187.03125 C 263.0625 170.863281 259.8125 156.867188 253.394531 145.1875 Z M 253.394531 145.1875 " fill-opacity="1" fill-rule="nonzero"/></g><g clip-path="url(#16fa2a243d)"><path fill="#000000" d="M 209.847656 314.574219 L 165.375 372.816406 L 2.175781 372.816406 L 2.175781 163.128906 L 83.386719 81.453125 L 83.386719 316.121094 L 187.261719 316.121094 C 194.996094 316.121094 202.578125 315.65625 209.847656 314.574219 Z M 185.792969 108.757812 L 140.621094 108.757812 L 140.621094 165.527344 L 200.875 109.839844 C 196.078125 109.144531 191.050781 108.757812 185.792969 108.757812 Z M 185.792969 108.757812 " fill-opacity="1" fill-rule="nonzero"/></g></svg>`;

const LOGO_TEXT_SVG = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="78" height="14" viewBox="41.34 161.53 287.72 51.72" preserveAspectRatio="xMinYMid meet" version="1.0"><defs><g/></defs><g fill="#0082fb" fill-opacity="1"><g transform="translate(45.342453, 209.249986)"><g><path d="M 21.703125 -7.03125 C 30.773438 -7.03125 35.3125 -12.367188 35.3125 -23.046875 C 35.3125 -32.140625 30.773438 -36.6875 21.703125 -36.6875 L 12.6875 -36.6875 L 12.6875 -7.03125 Z M 4.578125 0 L 4.578125 -43.71875 L 21.703125 -43.71875 C 36.171875 -43.71875 43.40625 -36.828125 43.40625 -23.046875 C 43.40625 -7.679688 36.171875 0 21.703125 0 Z M 4.578125 0 "/></g></g></g><g fill="#0082fb" fill-opacity="1"><g transform="translate(102.247486, 209.249986)"><g><path d="M 17.359375 -32.09375 C 27.109375 -32.09375 31.984375 -27.125 31.984375 -17.1875 C 31.984375 -15.851562 31.890625 -14.523438 31.703125 -13.203125 L 10.390625 -13.203125 C 10.390625 -8.679688 13.710938 -6.421875 20.359375 -6.421875 C 23.597656 -6.421875 26.835938 -6.726562 30.078125 -7.34375 L 30.078125 -0.921875 C 27.242188 -0.304688 23.800781 0 19.75 0 C 8.113281 0 2.296875 -5.472656 2.296875 -16.421875 C 2.296875 -26.867188 7.316406 -32.09375 17.359375 -32.09375 Z M 10.390625 -18.828125 L 24.09375 -18.828125 L 24.09375 -19.078125 C 24.09375 -23.515625 21.847656 -25.734375 17.359375 -25.734375 C 13.078125 -25.734375 10.753906 -23.429688 10.390625 -18.828125 Z M 10.390625 -18.828125 "/></g></g></g><g fill="#0082fb" fill-opacity="1"><g transform="translate(147.689832, 209.249986)"><g><path d="M 27.515625 -0.921875 C 24.867188 -0.304688 22.117188 0 19.265625 0 C 7.847656 0 2.140625 -5.550781 2.140625 -16.65625 C 2.140625 -26.945312 7.847656 -32.09375 19.265625 -32.09375 C 22.117188 -32.09375 24.867188 -31.789062 27.515625 -31.1875 L 27.515625 -24.765625 C 24.867188 -25.367188 22.320312 -25.671875 19.875 -25.671875 C 13.445312 -25.671875 10.234375 -22.664062 10.234375 -16.65625 C 10.234375 -9.832031 13.445312 -6.421875 19.875 -6.421875 C 22.320312 -6.421875 24.867188 -6.726562 27.515625 -7.34375 Z M 27.515625 -0.921875 "/></g></g></g><g fill="#000000" fill-opacity="1"><g transform="translate(187.936193, 209.249986)"><g><path d="M 17.96875 -21.859375 L 0.765625 -43.71875 L 11 -43.71875 L 23.078125 -27.765625 L 35.15625 -43.71875 L 45.390625 -43.71875 L 28.21875 -21.859375 L 45.390625 0 L 35.15625 0 L 23.078125 -15.953125 L 11 0 L 0.765625 0 Z M 17.96875 -21.859375 "/></g></g></g><g fill="#000000" fill-opacity="1"><g transform="translate(258.678824, 209.249986)"><g><path d="M 9.078125 0 L 0.765625 0 L 19.328125 -43.71875 L 28.03125 -43.71875 L 46.984375 0 L 38.28125 0 L 33.296875 -11.921875 L 18.765625 -11.921875 L 21.546875 -18.953125 L 30.359375 -18.953125 L 23.484375 -35.375 Z M 9.078125 0 "/></g></g></g><g fill="#000000" fill-opacity="1"><g transform="translate(312.372645, 209.249986)"><g><path d="M 12.6875 -43.71875 L 12.6875 0 L 4.578125 0 L 4.578125 -43.71875 Z M 12.6875 -43.71875 "/></g></g></g></svg>`;

// Script loader utility
const loadScript = (src) => {
  return new Promise((resolve, reject) => {
    if (document.querySelector(`script[src="${src}"]`)) {
      resolve();
      return;
    }
    const script = document.createElement('script');
    script.src = src;
    script.onload = resolve;
    script.onerror = reject;
    document.head.appendChild(script);
  });
};

export const invoiceGenerator = {
  generateInvoiceHTML(paymentOrder, userProfile) {
    const invoiceDate = new Date(paymentOrder?.paid_at || paymentOrder?.created_at);
    const invoiceNumber = `INV-${paymentOrder?.razorpay_order_id?.slice(-8)?.toUpperCase()}`;
    const currencySymbol = paymentOrder?.currency === 'INR' ? '₹' : '$';
    const amount = paymentOrder?.amount / 100;

    return `
<!DOCTYPE html>
<html lang="en">
<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>Invoice - ${invoiceNumber}</title>
    <style>
        * { margin: 0; padding: 0; box-sizing: border-box; }
        body { font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; color: #333; line-height: 1.6; padding: 40px; background: #f5f5f5; }
        .invoice-container { max-width: 800px; margin: 0 auto; background: white; padding: 60px; box-shadow: 0 0 20px rgba(0,0,0,0.1); }
        .header { border-bottom: 3px solid #2563eb; padding-bottom: 20px; margin-bottom: 30px; }
        .logo-wrapper { display: inline-flex; align-items: center; gap: 8px; margin-bottom: 8px; }
        .logo-wrapper svg { display: block; flex-shrink: 0; vertical-align: middle; }
        .header p { color: #666; font-size: 14px; }
        .invoice-details { display: flex; justify-content: space-between; margin-bottom: 40px; }
        .invoice-details div { flex: 1; }
        .invoice-details h3 { color: #2563eb; font-size: 14px; text-transform: uppercase; margin-bottom: 10px; }
        .invoice-details p { margin-bottom: 5px; font-size: 14px; }
        .invoice-table { width: 100%; border-collapse: collapse; margin-bottom: 30px; }
        .invoice-table th { background: #f8f9fa; padding: 15px; text-align: left; font-size: 14px; text-transform: uppercase; color: #666; border-bottom: 2px solid #e0e0e0; }
        .invoice-table td { padding: 15px; border-bottom: 1px solid #e0e0e0; font-size: 14px; }
        .total-section { text-align: right; margin-top: 20px; }
        .total-row { display: flex; justify-content: flex-end; margin-bottom: 10px; }
        .total-row span:first-child { margin-right: 40px; font-weight: 600; }
        .total-row.grand-total { font-size: 20px; color: #2563eb; font-weight: bold; padding-top: 15px; border-top: 2px solid #2563eb; }
        .payment-info { background: #f8f9fa; padding: 20px; border-radius: 8px; margin-top: 30px; }
        .payment-info h3 { color: #2563eb; margin-bottom: 10px; font-size: 16px; }
        .payment-info p { font-size: 14px; margin-bottom: 5px; }
        .footer { margin-top: 50px; padding-top: 20px; border-top: 1px solid #e0e0e0; text-align: center; color: #666; font-size: 12px; }
        .status-badge { display: inline-block; padding: 5px 15px; border-radius: 20px; font-size: 12px; font-weight: 600; text-transform: uppercase; }
        .status-paid { background: #d1fae5; color: #065f46; }
        @media print { body { padding: 0; background: white; } .invoice-container { box-shadow: none; } }
    </style>
</head>
<body>
    <div class="invoice-container">
        <div class="header">
            <div class="logo-wrapper">
                ${LOGO_ICON_SVG}
                ${LOGO_TEXT_SVG}
            </div>
            <p>Professional Pitch Deck Analysis &amp; Audit Services</p>
        </div>

        <div class="invoice-details">
            <div>
                <h3>Invoice To:</h3>
                <p><strong>${userProfile?.full_name || paymentOrder?.customer_name || 'N/A'}</strong></p>
                <p>${paymentOrder?.customer_email}</p>
                ${userProfile?.company_name ? `<p>${userProfile?.company_name}</p>` : ''}
                ${paymentOrder?.customer_phone ? `<p>${paymentOrder?.customer_phone}</p>` : ''}
            </div>
            <div style="text-align: right;">
                <h3>Invoice Details:</h3>
                <p><strong>Invoice #:</strong> ${invoiceNumber}</p>
                <p><strong>Date:</strong> ${invoiceDate?.toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })}</p>
                <p><strong>Payment ID:</strong> ${paymentOrder?.razorpay_payment_id || 'N/A'}</p>
                <p class="status-badge status-paid">Paid</p>
            </div>
        </div>

        <table class="invoice-table">
            <thead>
                <tr>
                    <th>Description</th>
                    <th style="text-align: center;">Quantity</th>
                    <th style="text-align: right;">Unit Price</th>
                    <th style="text-align: right;">Amount</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>
                        <strong>Paid Deck Audit - AI + Human Powered</strong><br>
                        <span style="color: #666; font-size: 13px;">Comprehensive pitch deck analysis with expert human review and AI-powered insights</span>
                    </td>
                    <td style="text-align: center;">1</td>
                    <td style="text-align: right;">${currencySymbol}${amount?.toFixed(2)}</td>
                    <td style="text-align: right;">${currencySymbol}${amount?.toFixed(2)}</td>
                </tr>
            </tbody>
        </table>

        <div class="total-section">
            <div class="total-row">
                <span>Subtotal:</span>
                <span>${currencySymbol}${amount?.toFixed(2)}</span>
            </div>
            <div class="total-row grand-total">
                <span>Total Amount Paid:</span>
                <span>${currencySymbol}${amount?.toFixed(2)}</span>
            </div>
        </div>

        <div class="payment-info">
            <h3>Payment Information</h3>
            <p><strong>Payment Method:</strong> ${paymentOrder?.payment_method || 'Razorpay'}</p>
            <p><strong>Payment Status:</strong> Captured</p>
            <p><strong>Transaction ID:</strong> ${paymentOrder?.razorpay_payment_id}</p>
            <p><strong>Order ID:</strong> ${paymentOrder?.razorpay_order_id}</p>
        </div>

        <div class="footer">
            <p><strong>Thank you for your business!</strong></p>
            <p>Professional Pitch Deck Analysis Services</p>
            <p>For support, contact us at support@mydeckaudit.com</p>
        </div>
    </div>
</body>
</html>
    `;
  },

  // Download invoice as PDF using jsPDF and html2canvas
  async downloadInvoicePDF(paymentOrder, userProfile) {
    try {
      // Load required libraries
      await loadScript('https://cdnjs.cloudflare.com/ajax/libs/html2canvas/1.4.1/html2canvas.min.js');
      await loadScript('https://cdnjs.cloudflare.com/ajax/libs/jspdf/2.5.1/jspdf.umd.min.js');

      const invoiceHTML = this.generateInvoiceHTML(paymentOrder, userProfile);
      const invoiceNumber = `INV-${paymentOrder?.razorpay_order_id?.slice(-8)?.toUpperCase()}`;

      // Create a temporary container
      const container = document.createElement('div');
      container.innerHTML = invoiceHTML;
      container.style.position = 'absolute';
      container.style.left = '-9999px';
      container.style.top = '0';
      document.body.appendChild(container);

      // Get the invoice container element
      const invoiceElement = container.querySelector('.invoice-container');

      // Use html2canvas to convert HTML to canvas
      const canvas = await window.html2canvas(invoiceElement, {
        scale: 2, // Higher quality
        useCORS: true,
        logging: false,
        backgroundColor: '#ffffff',
      });

      // Create PDF using jsPDF
      const { jsPDF } = window.jspdf;
      const imgWidth = 210; // A4 width in mm
      const imgHeight = (canvas.height * imgWidth) / canvas.width;
      
      const pdf = new jsPDF({
        orientation: imgHeight > imgWidth ? 'portrait' : 'portrait',
        unit: 'mm',
        format: 'a4',
      });

      const imgData = canvas.toDataURL('image/png');
      
      // Add image to PDF
      pdf.addImage(imgData, 'PNG', 0, 0, imgWidth, imgHeight);

      // Save the PDF
      pdf.save(`${invoiceNumber}.pdf`);

      // Clean up
      document.body.removeChild(container);

      return true;
    } catch (error) {
      console.error('PDF generation error:', error);
      // Fallback to HTML download
      this.downloadInvoice(paymentOrder, userProfile);
      return false;
    }
  },

  // Download invoice as HTML file (fallback)
  downloadInvoice(paymentOrder, userProfile) {
    const invoiceHTML = this.generateInvoiceHTML(paymentOrder, userProfile);
    const blob = new Blob([invoiceHTML], { type: 'text/html' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    const invoiceNumber = `INV-${paymentOrder?.razorpay_order_id?.slice(-8)?.toUpperCase()}`;

    link.href = url;
    link.download = `${invoiceNumber}.html`;
    document.body?.appendChild(link);
    link?.click();
    document.body?.removeChild(link);
    URL.revokeObjectURL(url);
  },

  // Open invoice in new window for printing
  printInvoice(paymentOrder, userProfile) {
    const invoiceHTML = this.generateInvoiceHTML(paymentOrder, userProfile);
    const printWindow = window.open('', '_blank');
    printWindow?.document?.write(invoiceHTML);
    printWindow?.document?.close();
    printWindow?.focus();
    setTimeout(() => {
      printWindow?.print();
    }, 250);
  }
};

export default invoiceGenerator;